'use client';

import {useState} from 'react';
import {X} from 'lucide-react';
import {Button} from '@manaboo/ui/button';
import {useCookieConsent, type CookieConsent} from './cookie-context';
import {CookiePreferences} from './cookie-preferences';

export function CookieBanner() {
	const {consent, updateConsent, loading} = useCookieConsent();
	const [showPreferences, setShowPreferences] = useState(false);

	if (consent ?? loading) {
		return null;
	}

	const handleAcceptAll = () => {
		updateConsent({necessary: true, analytics: true, marketing: true});
	};

	const handlePreferencesSaved = (newConsent: CookieConsent) => {
		updateConsent(newConsent);
		setShowPreferences(false);
	};

	return (
		<>
			<div className="bg-background fixed bottom-4 left-4 z-50 max-w-[300px] rounded-lg border p-4 shadow-lg">
				<Button
					variant="ghost"
					size="icon"
					className="absolute right-1 top-1"
					onClick={handleAcceptAll}
					aria-label="Zamknij"
				>
					<X className="h-4 w-4" />
				</Button>

				<h3 className="text-sm md:text-base">Ustawienia plików cookie</h3>

				<p className="text-muted-foreground mb-4 text-xs md:text-sm">
					Używamy plików cookie, aby poprawić Twoje doświadczenia. Kontynuując
					korzystanie z tej strony, zgadzasz się na używanie przez nas plików
					cookie.
				</p>

				<div className="space-y-2">
					<Button
						variant="default"
						size="sm"
						className="w-full"
						onClick={handleAcceptAll}
					>
						Akceptuj wszystkie
					</Button>
					<Button
						variant="outline"
						size="sm"
						className="w-full"
						onClick={() => {
							setShowPreferences(true);
						}}
					>
						Zarządzaj preferencjami
					</Button>
				</div>
			</div>

			{showPreferences ? (
				<CookiePreferences
					onClose={() => {
						setShowPreferences(false);
					}}
					onSave={handlePreferencesSaved}
				/>
			) : null}
		</>
	);
}
